import React, { useEffect, useState } from 'react'

import { THANKS_REMOTE_CONFIG_UPDATED_EVENT } from 'config/remoteConfig'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import theme from 'app/match/applicationReportPDF/assets/theme'
import ApplicationsCount from 'app/shared_components/navbar/components/applications_count/container'
import { urlTo } from 'app/sm/helpers'
import { FeatureFlag } from 'config/features'

const MyOwnershipButton = styled.button`
  .badge {
    padding: ${theme.space[1]}px ${theme.space[3]}px;
    border-radius: ${theme.radii[3]}px;
    background-color: ${theme.colors.watermelon};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes[2]}px;
    margin-left: ${theme.space[2]}px;
  }
`

const isActive = (_, location) => {
  return [
    /home\/overview/,
    /portfolio\/overview/,
    /agency.*\/bc\/dashboard/,
  ].some((route) => route.test(location.pathname))
}

const RENTER_PRIVACY_CENTRE_PATH = '/v2/sm/renter-privacy-centre'

const RenterNavbar = ({
  bcApplicationsCount = 0,
  to,
  applicationsCount = 0,
}) => {
  const [showPrivacyCentre, setShowPrivacyCentre] = useState(
    FeatureFlag.RenterPrivacyCentre.isOn,
  )

  useEffect(() => {
    const updatePrivacyCentreFlag = () => {
      setShowPrivacyCentre(FeatureFlag.RenterPrivacyCentre.isOn)
    }

    updatePrivacyCentreFlag()
    window.addEventListener(
      THANKS_REMOTE_CONFIG_UPDATED_EVENT,
      updatePrivacyCentreFlag,
    )

    return () => {
      window.removeEventListener(
        THANKS_REMOTE_CONFIG_UPDATED_EVENT,
        updatePrivacyCentreFlag,
      )
    }
  }, [])

  const handlePrivacyCentreClick = (event) => {
    event.preventDefault()
    window.location.href = RENTER_PRIVACY_CENTRE_PATH
  }

  return (
    <div>
      <div className="collapse-box pt0">
        <button
          data-target="#FindHomeMenu"
          data-menutoggle="true"
          className="collapsed"
          data-toggle="collapse"
        >
          My Home
        </button>
        <ul id="FindHomeMenu" className="collapse in">
          <li>
            <NavLink isActive={isActive} to={to}>
              <i className="icon-dasshboard" />
              <span>Dashboard</span>
            </NavLink>
          </li>
          {FeatureFlag.BondCover.isOn && (
            <li>
              <NavLink to={urlTo('dashboard')}>
                <i className="icon-bondcover" />
                <span>BondCover</span>
                <div className="badge">
                  {bcApplicationsCount ? bcApplicationsCount : 0}
                </div>
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to={urlTo('RentalReputation')}>
              <i className="icon-person"></i>
              <span>My Profile</span>
            </NavLink>
          </li>
          <ApplicationsCount applicationsCount={applicationsCount} />
          {FeatureFlag.Viewings.isOn && (
            <li>
              <NavLink to={urlTo('smViewings')}>
                <i className="icon-calendar" />
                <span>Viewings</span>
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to={urlTo('savedProperties')}>
              <i className="icon-saved" />
              <span>Saved Properties</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={urlTo('recentlyViewed')}>
              <i className="icon-recent" />
              <span>Recent Searches</span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="collapse-box pt0">
        <MyOwnershipButton
          data-target="#MyOwnershipMenu"
          data-menutoggle="true"
          className="collapsed"
          data-toggle="collapse"
        >
          My Ownership <div className="badge">Exclusive Offers</div>
        </MyOwnershipButton>
        <ul id="MyOwnershipMenu" className="collapse in">
          <li>
            <NavLink to={urlTo('invest')}>
              <i className="icon-dasshboard" />
              <span>Invest</span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="collapse-box pt0">
        <button
          data-target="#MySettingsMenu"
          data-menutoggle="true"
          className="collapsed"
          data-toggle="collapse"
        >
          My Settings
        </button>
        <ul id="MySettingsMenu" className="collapse in">
          <li>
            <NavLink to={urlTo('MyAccount')}>
              <i className="icon-user"></i>
              <span>My Account</span>
            </NavLink>
          </li>
          {showPrivacyCentre && (
            <li>
              <a
                href={RENTER_PRIVACY_CENTRE_PATH}
                onClick={handlePrivacyCentreClick}
              >
                <i className="icon-lock"></i>
                <span>Privacy Centre</span>
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default RenterNavbar
